'use client'
import { Box } from '@mui/material'
import { Image } from '@aws-amplify/ui-react'

export default function Home() {
  return (
    <Box
      sx={{
        background: '#eee',
        display: 'flex',
        height: '80vh',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Box width={600} height={200}>
        <Image src='/logo.png' alt='logo' loading='lazy' />
      </Box>
    </Box>
  )
}
